var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Man-Lavador-Principal"},[_c('PageTitle',{attrs:{"icon":"fa fa-bus","main":" Veiculo(s) no Lavador","sub":"Lançamentos"}}),_c('div',{staticClass:"Man-Lavador-Principal"},[_c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Lavador","active":""}},[_c('ManutencaoLavadorLancamento')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }